import * as Yup from 'yup'
import { REJECT_REASON } from 'domains/customer-refund/constants'

const customerRefundRejectFormSchema = Yup.object().shape(
  {
    reject_reason: Yup.string()
      .oneOf(Object.values(REJECT_REASON),'invalid reject reason')
      .required('reject reason required')
  }
)

export default customerRefundRejectFormSchema
